module.exports = __webpack_public_path__ + "static/media/Jackolantern.6f33d31a.mp3";